"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var S = __importStar(require("./LftProgressBar.styles"));
var LftTypography_1 = __importDefault(require("../LftTypography"));
var LftProgressBar = function (_a) {
    var control = _a.control, bgColor = _a.bgColor, _b = _a.id, id = _b === void 0 ? 'carregando' : _b, _c = _a.size, size = _c === void 0 ? 'sm' : _c, _d = _a.status, status = _d === void 0 ? 'default' : _d, value = _a.value;
    return ((0, jsx_runtime_1.jsxs)(S.Wrapper, __assign({ "aria-label": id, bgColor: bgColor, role: 'progressbar', id: id }, { children: [(0, jsx_runtime_1.jsx)(S.ProgressBarStyled, { "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": value, control: control, bgColor: bgColor, "data-lift": "lft-progressbar", max: 100, value: value, size: size, status: status }, void 0), !!control && ((0, jsx_runtime_1.jsx)(S.ProgressBarLabel, { children: (0, jsx_runtime_1.jsxs)(LftTypography_1.default, __assign({ component: 'caption' }, { children: [value, "%"] }), void 0) }, void 0))] }), void 0));
};
exports.default = LftProgressBar;
